<template>
  <div class="c-table" ref="shutdowndetailtable">
    <el-table v-loading="loading" :data="data" :height="height" border stripe>
      <slot></slot>
      <template slot="empty">
        <no-data />
      </template>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-retry', scope.row)" v-if="!scope.row.isSuccess">重试</el-button>
          </div>
          <span v-else-if="col.key === 'opType'">暂停计划</span>
          <span v-else-if="col.key === 'isSuccess'">{{ scope.row[col.key] | transStatus(scope.row) }}</span>
          <span v-else-if="col.key === 'imageDetailNames'">{{ scope.row[col.key] || '————' }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'upTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
export default {
  name: 'shutdowndetailtable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    }
  },
  filters: {
    transStatus(val, row) {
      let type
      switch (val) {
        case 0:
          type = '失败' + (row.errorMsg ? '，' + row.errorMsg : '')
          break
        case 1:
          type = '成功'
          break
        default:
          type = '未知'
          break
      }
      return type
    }
  },
  data() {
    return {
      height: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      timeout(0).then(() => {
        this.$refs.shutdowndetailtable && (this.height = this.$refs.shutdowndetailtable.offsetHeight - 7)
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  height: calc(100% - 32px);
  background-color: #fff;
  padding: 0 0 7px;
  z-index: 9;

  .el-table {
    height: 100%;
  }

  .c-control-margin {
    margin: 0;
    padding: 0 6px;
  }
}
</style>
